import React, { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";

/**
 * Mount animation — fades + slides its children in when they first appear.
 * Used for progressively-revealed form fields so a new field eases in instead
 * of popping. Web-friendly (JS-driven; RN-web maps it to CSS transforms).
 */
function NtAppearIn({ children, style, duration = 240, offset = 10, delay = 0 }) {
  const v = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const anim = Animated.timing(v, {
      toValue: 1,
      duration,
      delay,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: false,
    });
    anim.start();
    return () => anim.stop();
  }, [v, duration, delay]);

  return (
    <Animated.View
      style={[
        {
          opacity: v,
          transform: [
            { translateY: v.interpolate({ inputRange: [0, 1], outputRange: [offset, 0] }) },
          ],
        },
        style,
      ]}
    >
      {children}
    </Animated.View>
  );
}

export default NtAppearIn;
